<template>
  <transition name="slide-up">
    <div class="action-buttons-section" v-show="visible || scrollView">
      <div class="action-buttons-section__inner">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

export type DataType = {
  scrollView: boolean
}

/**
 * 共通ペイン: フッターボタンアクションシート
 */
export default defineComponent({
  name: 'ActionButtonsSection',
  components: {},
  data() {
    return {
      /**
       * スクロール計測時 表示フラグ
       */
      scrollView: false,
    }
  },
  props: {
    /**
     * スクロール計測ターゲット
     */
    scrollTargetSelector: {
      type: String,
      default: '',
    },
    /**
     * 初期表示フラグ
     */
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const scrollTargetDom = computed(() => document.querySelector(props.scrollTargetSelector))
    return {
      scrollTargetDom,
    }
  },
  mounted() {
    /**
     * ターゲットが指定されていれば、最下部までスクロールで表示
     */
    if (this.scrollTargetDom) {
      this.scrollTargetDom.addEventListener('scroll', this.watchScrollTarget, false)
      // 入力項目が少ないとスクロールが発生しない場合があるため、最初に一度だけ強制的に呼び出す
      this.$nextTick(() => {
        this.watchScrollTarget()
      })
    }
  },
  beforeDestroy() {
    /**
     * ターゲットが指定されていれば、リスナー解除
     */
    if (this.scrollTargetDom) {
      this.scrollTargetDom.removeEventListener('scroll', this.watchScrollTarget, false)
    }
  },
  methods: {
    /**
     * スクロール量監視
     * 最下部まで表示されたらDOMを表示
     */
    watchScrollTarget() {
      if (this.scrollTargetDom) {
        const scrollTargetHeight: number = this.scrollTargetDom.clientHeight
        const scrollValue: number = this.scrollTargetDom.scrollHeight
        if (
          scrollValue - (scrollTargetHeight + this.scrollTargetDom.scrollTop) < 20 ||
          this.visible
        ) {
          this.scrollView = true
        }
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.action-buttons-section {
  position: fixed;
  bottom: calc(#{$globalNavigationHeight} + #{env(safe-area-inset-bottom)});
  left: 0;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 5%);
  transition: all ease 0.3s;

  &.slide-up-enter-active,
  &.slide-up-leave-active {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  &.slide-up-enter,
  &.slide-up-leave-to {
    opacity: 0;
    transform: translateY(100%);
    pointer-events: none;
  }

  &__inner {
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
    gap: 8px;
    width: 100%;
    max-width: $responsiveMypageMaxWidth;
    padding: 16px min(4.2667vw, 16px);
    margin: 0 auto;

    @media screen and (min-width: $responsiveTabletWidth) {
      max-width: none;
    }
  }
}
</style>

<style lang="scss">
.action-buttons-section__inner {
  @media screen and (min-width: $responsiveTabletWidth) {
    .atom-router-btn,
    .atom-input-btn {
      max-width: 345px;
      margin: 0;
    }
  }
}
</style>
